import { FC } from 'react'
import type { CrmIntegrationAttachment } from '../../types/crm-integration-chat.types'
import {
  attachmentVoiceSrc,
  attachmentVoiceWaveform,
} from '../../lib/crmIntegrationAttachment'
import CrmIntegrationVoicePlayer from './CrmIntegrationVoicePlayer'
import classes from '../../styles/crmIntegrationChat.module.css'

type CrmIntegrationIncomingVoiceProps = {
  att: CrmIntegrationAttachment
  onPlaybackError?: () => void
}

const CrmIntegrationIncomingVoice: FC<CrmIntegrationIncomingVoiceProps> = ({
  att,
  onPlaybackError,
}) => {
  if (att.kind !== 'voice') {
    return null
  }

  const src = attachmentVoiceSrc(att)
  const waveform = attachmentVoiceWaveform(att)

  if (!src) {
    return (
      <span className={classes.bubbleAttachmentLink}>
        Голосовое сообщение недоступно
      </span>
    )
  }

  return (
    <div className={classes.bubbleVoiceCard}>
      <CrmIntegrationVoicePlayer
        src={src}
        durationSec={att.duration}
        waveform={waveform}
        onPlaybackError={onPlaybackError}
      />
    </div>
  )
}

export default CrmIntegrationIncomingVoice
